import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import loginApi from '@/api/PcModule/login';
import qs from 'qs'
const service = axios.create();
let isRetryRequest  = false
// 设置请求头和请求路径
// axios.defaults.baseURL = '/gs'
let api = import.meta.env.VITE_SECOND_BASE_API
console.log(api,  'api')
// 二期接口
let secondApi = [
    '/open/center/api/wxqy/getTicket',
    '/open/center/api/wxqy/getContactWay',
    '/open/center/api/wxqy/getGsUserId',
    
]

// let api = 'https://api-test.gansuan.com/gs'
// let api = 'https://api.gansuan.com/gs'
// let api = 'https://192.168.100.163:8833'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
import { message } from '@/utils/resetMessage'
let postArr = [
    // api+'/auth/oauth/token',
    api+'/user/center/oauth/token', //  // 更换二期接口
    api+'/auth/login',
    api+'/auth/oauth/check_token',
]
// import localStorageUtils from '@/utils/localstorage'
import dealObjectValue from '@/utils/clearNull'
import router from '@/router/Index';
import { Base64 } from 'js-base64';
// Request interceptors
service.interceptors.request.use(
    (config: AxiosRequestConfig) => {
        api = import.meta.env.VITE_SECOND_BASE_API
        console.log(api + config.url)
        // 二期接口域名
        if(secondApi.includes(config.url)){
            api = import.meta.env.VITE_SECOND_BASE_API
        }
        else if(config.data?.isApi2 === true || postArr.includes(api + config.url)){
            api = import.meta.env.VITE_SECOND_BASE_API
        }
        else{
            // 一期接口域名
            api = import.meta.env.VITE_BASE_API
        }
        config.data?.isApi2 ? delete config.data?.isApi2 : ''
        let user = JSON.parse(localStorage.getItem('user')) || {}
        let userInfo = user.userInfo || {}
        let temporaryUserInfo = user.temporaryUserInfo || {}
        let data = qs.parse(config.data)
        let params = {}
        if('/user/center/api/update' == config.url || '/pay/tonglianpay/getPayUrl' == config.url){
            params = data
        }else{
            params = dealObjectValue(data)
        }
        let shortUrl = config.url
        config.url = api + config.url
        if (postArr.indexOf(config.url) != -1) {
            config.headers['Authorization'] = 'Basic ZmYtYXV0aDpjaGFuZzg4ODg='
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
            api = import.meta.env.VITE_SECOND_BASE_API
        } else if (userInfo.access_token && import.meta.env.VITE_SECOND_BASE_API === api) {
            config.headers['Authorization'] = 'Bearer ' + userInfo.access_token
            config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        } else if (temporaryUserInfo.access_token){
            config.headers['Authorization'] = 'Bearer ' + temporaryUserInfo.access_token
            config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        }
        // 企业微信的客户详情相关接口不需要token
        if(secondApi.includes(shortUrl)){
            delete  config.headers['Authorization']
        }
        params['tenantId'] = '2287838788945248256'
        // if(config.url === api+ '/system/sysFile/upload' || config.url === api+ '/system/enterpriseCertification/uploadCertificationImg' || config.url === api+ '/open/center/oss/fileUpload'){
        //     config.headers['Content-Type'] = 'multipart/form-data;'
        // }
        // 埋点来源添加到请求头上
        if (localStorage.getItem('trackParams')) {
            config.headers['trackParams'] = Base64.encodeURI(localStorage.getItem('trackParams'));
        }
        if (config.method === 'post') {
            if (postArr.indexOf(config.url) != -1) {
                config.data = qs.stringify({
                    ...params,
                })
            } 
            // else if (config.url !== api +  '/system/pic/upload' && config.url !== api +  '/system/sysFile/upload' && config.url !== api +  '/system/enterpriseCertification/uploadCertificationImg') {
            //     config.data = params
            // }
        } else if (config.method === 'get') {
            config.params = params
        } else if (config.method === 'put') {
            config.data = params
        } else if (config.method === 'delete') {
            config.params = params
        }
        isRetryRequest = false
        return config;
    },
    (error: any) => {
        Promise.reject(error);
    }
);

// Response interceptors
service.interceptors.response.use(
    (response: AxiosResponse) => {
        if(response.config.url === api + '/order/trade/data'){
            return response.data
        }else{
            if (response.data.code == 500) {
                // console.log(response.data.message , 'response.data.message')
                if(response.config.url != api +'/order/sampleOrder/trade/data'&& response.config.url != api +'/order/trade/data'&& response.config.url != api +'/product/sampleChecklist/save' && response.config.url != api + '/order/orderContract/save'){
                    message({
                        type: 'error',
                        message: response.data.message
                    })
                }
                return response.data
            } if (response.data.code == 400) {
                message({
                    type: 'error',
                    message: response.data.message
                })
                return response.data
            } else {
                return response.data
            }
        }
    },
    (error: any) => {
        if (error.response) {
            console.log(error.config.__isRetryRequest , 'error.config.__isRetryRequest')
            if (error.response.config.url === api + '/auth/oauth/check_token' || error.response.config.url === api + '/user/center/oauth/token') {
                return error.response.data
            } else if (error.response.config.url === api + '/auth/login') {
                message(
                    {
                        type: 'error',
                        message: error.response.data.message
                    }
                )
                // ElMessage.error(error.response.data.message)
                // return error.response.data.message
            } else if ((error.response.status === 401 || error.response.status === 400) && !isRetryRequest) {
                isRetryRequest = true;
                let user = JSON.parse(localStorage.getItem('user')) || {}
                let userInfo = user.userInfo || {}
                isDisableAction(userInfo.id).then((status) => {
                    if(status){
                        ElMessageBox.alert('您的账号已被锁定，请联系客服（服务热线：400-860-3536）了解详情', '提示', {
                            confirmButtonText: '确认',
                            customClass: 'isDisableUser',
                            center: true,
                            callback: () => {
                                if (error.response.status === 401 || userInfo.access_token) {
                                    const trackParams = localStorage.getItem('trackParams');
                                    localStorage.clear()
                                    if (trackParams) {
                                        localStorage.setItem('trackParams', trackParams);
                                    }
                                    setTimeout(function() {
                                        location.reload();
                                    }, 0);
                                }
                                // ElMessage.error(error.response.data.error_description)
                            },
                        });
                    }else{
                        if (error.response.status === 401 || userInfo.access_token) {
                            const trackParams = localStorage.getItem('trackParams');
                            localStorage.clear()
                            if (trackParams) {
                                localStorage.setItem('trackParams', trackParams);
                            }
                            setTimeout(function() {
                                location.reload();
                            }, 0);
                        }
                        ElMessage.error(error.response.data.error_description)
                    }
                })
                
            }
        }
        return Promise.reject(error.response);
    }
)
function  isDisableAction(id) {
    return axios.get(import.meta.env.VITE_SECOND_BASE_API + '/user/center/api/client/is/disable', {
        params: {
            id,
        }
    }).then(response => {
        return response.data.data;
    });
}
export default service;

